export default __webpack_public_path__ + "static/media/Urano.607cb33c.png";